import React, { Component } from 'react';
import Config from '../../Util/config';
import HttpUtil from '../../Util/httpUtil';
import { Container, Row, Col } from 'reactstrap';
import "../../_Content/css/erros.css"

class Erros extends Component {
    constructor(props) {
        super(props);
    };

    redirect = () =>{
        window.location = "https://www.econeteditora.com.br/";
    }

    render(){
        return(
            <Container id="errorPageContainer">
                <Row id="errorPage">
                    <Col>
                        <h1>Desculpe, algo deu errado</h1>
                        <p>
                            Parece que você não tem acesso à essa parte do sistema, ou o
                            link que você procura não existe.
                        </p>
                        <p>
                            Tente: 
                        </p>
                        <p>
                            1º Efetuar a liberação dos seguintes endereços em seu firewall e
                            efetuar a liberação como site seguro dos endereços abaixo:
                        </p>
                        <p>
                            <span className="link">econeteditora.curitiba.br</span>
                            <span className="link">ecoauditbasewebservico-env.us-east-1.elasticbeanstalk.com</span>
                            <span className="link">auditor-cont.econeteditora.com.br</span>
                            <span className="link">auditor-fiscal.econeteditora.com.br</span>
                            <span className="link">auditor.econeteditora.com.br:3000.</span>
                        </p>
                        <p>
                            2º Efetuar a limpeza de cache.
                        </p>
                        <button onClick={this.redirect} className="ecobtn fat vazado branco">Home</button>
                    </Col>
                    <Col>
                        <img src="/img/ecoicos/warning.png" width="190"/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default Erros;


// WEBPACK FOOTER //
// ./src/Componente/Common/Erros.jsx